<!-- <div class="position-relative w-100 mb-2">
  <div class="input-group input-group-sm">
    <input
      [required]="e['required'] == 1"
      [type]="e.type"
      [(ngModel)]="entryData"
      (input)="onUserInput($event)"
      (blur)="hideDropdownDelayed()"
      class="form-control form-control-sm combobox1"
      [id]="e.code + '_input'"
      [name]="e.code + '_input'"
      placeholder="Add / Search"
      [readonly]="readonly"
    />
    <button
      class="btn btn-outline-secondary"
      type="button"
      (click)="toggleDropdown()"
      [disabled]="readonly"
    >
      +
    </button>
  </div>
  <ul
    class="list-group position-absolute w-100"
    *ngIf="showDropdown"
    style="z-index: 1000; max-height: 200px; overflow-y: auto"
    [id]="e.code + '_ul'"
  >
    <li
      *ngFor="let c of filteredValues"
      class="list-group-item list-group-item-action"
      (mousedown)="selectItem(c)"
    >
      {{ c }}
    </li>
  </ul>
</div> -->

<mat-form-field
  appearance="outline"
  class="w-100 mb-2 compact-inputs dropdown-pd-none"
>
  <input
    type="text"
    matInput
    [required]="e['required'] == 1"
    [type]="e.type"
    [(ngModel)]="entryData"
    (input)="onUserInput($event)"
    (blur)="hideDropdownDelayed()"
    [id]="e.code + '_input'"
    [name]="e.code + '_input'"
    [readonly]="readonly"
    [matAutocomplete]="auto"
    placeholder="Add / Search"
  />

  <button
    mat-icon-button
    matSuffix
    type="button"
    (click)="toggleDropdown()"
    [disabled]="readonly"
    class="icon-pd-none"
  >
    <mat-icon>add</mat-icon>
  </button>

  <mat-autocomplete #auto="matAutocomplete">
    <mat-option
      *ngFor="let c of filteredValues"
      [value]="c"
      (onSelectionChange)="selectItem(c)"
    >
      {{ c }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
